var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 6.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1654 10L17.132 7.675L17.4154 4.6L14.407 3.91667L12.832 1.25L9.9987 2.46667L7.16536 1.25L5.59036 3.90833L2.58203 4.58333L2.86536 7.66667L0.832031 10L2.86536 12.325L2.58203 15.4083L5.59036 16.0917L7.16536 18.75L9.9987 17.525L12.832 18.7417L14.407 16.0833L17.4154 15.4L17.132 12.325L19.1654 10ZM7.81536 13.3417L5.83203 11.3417C5.75478 11.2646 5.69349 11.173 5.65167 11.0722C5.60985 10.9714 5.58833 10.8633 5.58833 10.7542C5.58833 10.645 5.60985 10.537 5.65167 10.4361C5.69349 10.3353 5.75478 10.2438 5.83203 10.1667L5.89036 10.1083C6.21536 9.78333 6.7487 9.78333 7.0737 10.1083L8.41536 11.4583L12.707 7.15833C13.032 6.83333 13.5654 6.83333 13.8904 7.15833L13.9487 7.21667C14.2737 7.54167 14.2737 8.06667 13.9487 8.39167L9.01536 13.3417C8.6737 13.6667 8.1487 13.6667 7.81536 13.3417Z",
    fill: "#147BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue_tick.9eaec42f359605d5d515b3c2247161dd.svg";
export { ForwardRef as ReactComponent };